import { metaTagString } from '../../utilities/meta_tags_util';

const HTML_LANG = 'zh-tw';

export default (urlPath, language, query, params) => {
  let metaData = '';

  metaData += metaTagString({
    urlPath,
    title: '旅宿數位轉型計畫',
    images: ['https://assets.funliday.com/og-image/ogimage_hostel.png'],
    description:
      '為解決民宿長久以來與旅客溝通問題，Funliday 推出「旅宿數位轉型計畫」，旅宿業者可建立自己的推薦行程及私房景點，透過 Funliday 更快速且有效的分享給即將入住的旅人。',
    language: HTML_LANG,
    noindex: false,
  });

  return {
    metaData,
    htmlLang: HTML_LANG,
  };
};
